var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"channel-box",attrs:{"to":_vm.routePath}},[_c('span',{staticClass:"channel-box__name h4"},[_vm._v(_vm._s(_vm.label))]),_c('Icon',{attrs:{"name":"chevron","size":24}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }